export const version = 'kunde-v1.15.0-SNAPSHOT-96958952b98e28ddf1c925f678057e9f00b0858d';